import React, { FC, ReactNode, useEffect, useState } from "react";

export interface IShowMoreLessItem {
  isShown?: boolean;
  showMoreLabel?: ReactNode;
  showLessLabel?: ReactNode;
  onChange?: (isShow: boolean) => void;
}

const ShowMoreLess: FC<IShowMoreLessItem> = ({
  isShown,
  showMoreLabel = "show more",
  showLessLabel = "show less",
  onChange,
}) => {
  const [show, setShowMore] = useState<boolean>(isShown);

  useEffect(() => {
    setShowMore(isShown);
  }, [isShown]);

  const showText = show ? showLessLabel : showMoreLabel;

  const handleChange = () => {
    setShowMore(!show);
    onChange && onChange(!show);
  };

  return (
    <button
      type="button"
      className="filter-showmore"
      data-testid="show-more-less"
      onClick={handleChange}
    >
      {showText}
    </button>
  );
};

export default ShowMoreLess;
